import { render, staticRenderFns } from "./Listar.vue?vue&type=template&id=20226c4d&scoped=true"
import script from "./Listar.vue?vue&type=script&lang=js"
export * from "./Listar.vue?vue&type=script&lang=js"
import style0 from "./Listar.vue?vue&type=style&index=0&id=20226c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20226c4d",
  null
  
)

export default component.exports